// extracted by mini-css-extract-plugin
export default {"draggable":"MouseDrag_draggable__jECcK","active":"MouseDrag_active__lGuZ4"};